<template>
  <section class="all-cases-view">
    <div class="container-default">
      <div class="listings-navbar">
        <el-row>
          <el-col :lg="7">
            <ul class="d-flex list-items-group-15 barcode-print">
              <li>
                <el-button
                  class="btn button-with-icon"
                  @click="goToCreateFile()"
                >
                  <span class="mr-8">
                    <img
                      src="@/assets/images/icons/plus-icon.svg"
                      alt="icon"
                      class="inactive"
                    />
                    <img
                      src="@/assets/images/icons/plus-icon-white.svg"
                      alt="icon"
                      class="active"
                    />
                  </span>
                  <span>Create Report File</span>
                </el-button>
              </li>
            </ul>
          </el-col>
          <el-col :lg="17">
            <ul
              class="d-flex flex-wrap justify-content-end list-items-group-15"
            >
              <li>
                <div class="form-element input-with-icon search-input-lg">
                  <el-input
                    placeholder="Search name"
                    v-model="searchString"
                    @input="getAutoCompleteCases()"
                    :clearable="true"
                  ></el-input>
                  <span>
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid icon"
                    />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="reportsList.data"
            v-loading="loading"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            @sort-change="onChangeSort"
          >
            <el-table-column
              label="NAME"
              prop="title"
              sortable="custom"
              min-width="220"
            >
              <template #default="scope"
                ><span @click="onEdit(scope.row)" class="cursor">{{
                  scope.row.title
                }}</span></template
              ></el-table-column
            >
            <el-table-column label="CASE TYPE" prop="case_type" width="180">
              <template #default="scope">
                <span v-if="scope.row.case_type == 'CARDIAC'">
                  Cardiac Panel
                </span>
                <span v-else> Pulmonary Panel </span>
              </template>
            </el-table-column>
            <el-table-column label="Drop.csv" min-width="120">
              <template v-slot="scope">
                <el-button
                  class="btn-active"
                  v-if="!scope.row.sent_status"
                  @click="onSendCSV(scope.row._id)"
                  >SEND
                </el-button>
                <el-tooltip
                  :content="momentWithTimezone(scope.row.sent_on, 'MM-DD-YYYY')"
                  placement="top"
                  effect="dark"
                  v-else
                >
                  <el-button class="btn-success">SENT</el-button>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="Report Status" min-width="120">
              <template #default="{ row }">
                <el-button
                  class="btn-active"
                  v-if="row.sync_status == 'TO-START'"
                  :disabled="!row.sent_status"
                  @click="onSync(row._id)"
                  >SYNC</el-button
                >
                <el-button class="btn-success-cursor-text" v-else>{{
                  row.sync_status
                }}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="Progress" width="160">
              <template v-slot="scope">
                <router-link
                  :to="{
                    name: 'viewGenedTestResults',
                    params: { id: scope.row._id },
                    query: {
                      ...this.$route.query,
                      redirectRoute: this.$route.name,
                    },
                  }"
                  >View Progress</router-link
                >
              </template>
            </el-table-column>
            <el-table-column
              label="CREATED BY"
              prop="created_by"
              sortable="custom"
              width="220"
            >
              <template v-slot="scope">
                {{ scope.row.created_by.first_name
                }}{{ scope.row.created_by.last_name }}
              </template>
            </el-table-column>
            <el-table-column
              label="CREATED ON"
              prop="created_at"
              sortable="custom"
              min-width="120"
            >
              <template v-slot="scope">
                <div v-if="scope.row.created_at" class="d-flex">
                  <div class="date pr-10">
                    {{ momentWithTimezone(scope.row.created_at, "MM-DD-yyyy") }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="action"
              label="ACTION"
              fixed="right"
              width="120"
            >
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li>
                    <el-button
                      :disabled="scope.row.sent_status"
                      @click="onEdit(scope.row)"
                      title="Edit"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/edit-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/edit-deactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>

                  <li @click="downloadBatch(scope.row)">
                    <el-button title="Download">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/download-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/download-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li @click="archiveConfirm(scope.row)">
                    <el-button title="Delete">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/delete-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/delete-deactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
          <div class="listings listings__pagination">
            <el-pagination
              v-model:currentPage="page"
              v-model:page-size="pageSize"
              :page-sizes="[10, 25, 50, 100]"
              layout=" prev, pager, next, jumper, sizes ,total"
              :total="reportsList.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import FilterHelper from "@/mixins/FilterHelper";
import caseConstants from "@/config/constants/caseConstants";

export default {
  data() {
    return {
      orderBy: "",
      orderType: "",
      loading: false,
      reportsList: {},
      searchBy: "",

      searchByKey: ["Name"],
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      pageSize: 25,
      page: 1,
      searchString: "",
    };
  },
  props: {
    selectedCaseType: {
      default: "",
    },
  },
  computed: {
    isSearchByInput() {
      return this.searchByKey.indexOf(this.searchBy) != -1 ? true : false;
    },
    ...mapGetters("reportFiles", [
      "getReportFiles",
      "getSendDropCSVStatus",
      "getSyncReportStatus",
      "getReportDeleteStatus",
    ]),
  },
  mixins: [FilterHelper],
  async mounted() {
    this.setQueryParams();
    await this.getReports();
  },
  methods: {
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "created_at";
        this.orderType = "DESC";
      }
      this.getReports();
    },
    clearInputSearch() {
      if (this.search_string) {
        this.searchString = "";

        this.isSearchByInput = "";
        this.getReports(1);
      }
    },
    goToCreateFile() {
      this.$router.push({
        name: "addGenedTestResults",
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    getAutoCompleteCases() {
      setTimeout(() => {
        this.page = 1;
        this.getReports();
      }, 600);
    },
    onEdit(row) {
      this.$router.push({
        name: "editGenedTestResults",
        params: { id: row._id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    archiveConfirm(data) {
      this.$confirm(`Are you sure want to DELETE ${data.title}?`, "Warning", {
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(async () => {
        await this.archiveReportFile(data);
      });
    },
    async archiveReportFile(data) {
      this.loading = true;
      await this.$store.dispatch("reportFiles/delete", data._id);
      this.loading = false;
      if (this.getReportDeleteStatus) {
        this.$notify({
          type: "success",
          title: "Success",
          message: "Reports List deleted successfully",
        });
        await this.getReports(this.page);
      } else {
        this.$notify({
          title: "Error",
          message: "Error in deleting Reports List",
        });
      }
    },
    async downloadBatch(data) {
      try {
        this.loading = true;
        await this.$store.dispatch("reportFiles/download", {
          id: data._id,
          name: data.title,
        });
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async onSync(id) {
      this.loading = true;
      await this.$store.dispatch("reportFiles/syncReport", id);
      this.loading = false;
      if (this.getSyncReportStatus) {
        this.$notify({
          type: "success",
          title: "Success",
          message: "Reports syncing process started successfully",
        });
        await this.getReports(1);
      } else {
        this.$notify.error({
          title: "Error",
          message: "Error in starting Reports syncing process",
        });
      }
    },
    async onSendCSV(id) {
      this.loading = true;
      await this.$store.dispatch("reportFiles/sendDropCSV", id);
      this.loading = false;
      if (this.getSendDropCSVStatus) {
        this.$notify({
          type: "success",
          title: "Success",
          message: "Drop.csv sent successfully",
        });
        await this.getReports(1);
      } else {
        this.$notify.error({
          title: "Error",
          message: "Error in sending Drop.csv",
        });
      }
    },
    prepareParams() {
      let params = { page: this.page, limit: this.pageSize };
      if (this.selectedCaseType) {
        params.case_type = this.selectedCaseType;
      } else {
        params.case_type = "CARDIAC";
      }
      if (this.searchString) {
        params.search_string = this.searchString;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      return params;
    },
    setQueryParams() {
      this.page = this.$route.query.selectedGenePage
        ? parseInt(this.$route.query.selectedGenePage)
        : 1;
      this.pageSize = this.$route.query.selectedGenePageSize
        ? parseInt(this.$route.query.selectedGenePageSize)
        : 25;

      this.searchString = this.$route.query.selectedGeneString;
      if (this.$route.query.selectedGeneOrderBy) {
        this.orderBy = this.$route.query.selectedGeneOrderBy;
      }
      if (this.$route.query.selectedGeneOrderType) {
        this.orderType = this.$route.query.selectedGeneOrderType;
      }
    },
    async getReports() {
      this.loading = true;

      let params = this.prepareParams();
      await this.$store.dispatch("reportFiles/fetchAll", params);
      this.reportsList = JSON.parse(JSON.stringify(this.getReportFiles));

      this.updateQueryParams(params);

      this.loading = false;
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedGenePage: params.page,
        selectedGeneString: params.search_string,

        selectedGenePageSize: params.limit,
        selectedGeneOrderBy: params.order_by,
        selectedGeneOrderType: params.order_type,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.getReports(this.page);
    },
    handleCurrentChange(page) {
      this.page = page;

      this.getReports(this.page);
    },
  },
};
</script>
<style lang="scss">
@mixin button-css {
  border-radius: 4px !important;
  padding: 6px 5px;
  height: auto;
  min-height: 20px;
  line-height: 1;
  background: #f2f2f2;
  border: 0.6px solid #4bb543;
  color: #4bb543;
  min-width: 100px;
  font-weight: 500 !important;
  text-align: center;
  font-size: 12px !important;
  letter-spacing: 0px !important;
  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #4bb543;
    color: #4bb543;
  }
}
.btn-success-cursor-text {
  @include button-css;
  cursor: text !important;
}
.btn-success {
  @include button-css;
}
.btn-danger {
  @include button-css;
  background: #f2f2f2;
  border: 0.6px solid #eb5757;
  color: #eb5757;
  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #eb5757;
    color: #eb5757;
  }
  &.is-disabled {
    opacity: 0.5;
    background: #f2f2f2;
    border: 0.6px solid #eb5757;
    color: #eb5757;
    &:hover {
      opacity: 0.5;
      background: #f2f2f2;
      border: 0.6px solid #eb5757;
      color: #eb5757;
    }
  }
}
.btn-active {
  @include button-css;

  background: #f2f2f2;
  border: 0.6px solid #5162fd;
  color: #5162fd;
  &:hover,
  &:active,
  &:focus {
    background: #f2f2f2;
    border: 0.6px solid #5162fd;
    color: #5162fd;
  }
  &.is-disabled {
    opacity: 0.5;
    background: #f2f2f2;
    border: 0.6px solid #5162fd;
    color: #5162fd;
    &:hover {
      opacity: 0.5;
      background: #f2f2f2;
      border: 0.6px solid #5162fd;
      color: #5162fd;
    }
  }
}
</style>
